module.exports = __webpack_public_path__ + "img/paypal.fca47a1d.png";